import React, { useEffect, useState } from 'react';

// Components
import { renderEntityBasicInfo, renderPills, renderEntityInfoGrid, renderActions } from './EntityDetailsRenderers';

// Libraries

// Types
import { Action, BasicInfo, EntityDetails, Pill } from '@/types/EntityDetails';

// Utils
import EntityDetailsSummaryMobileView from './EntityDetailsSummaryMobileView';
import useScreenSize from '@/hooks/useScreenSize';
import EntityDetailsSummaryTabletView from './EntityDetailsSummaryTabletView';

type DispatchProps = {};

type Props = DispatchProps & {
  actions?: Action[];
  entityBasicInfo?: BasicInfo[];
  entityDetails?: EntityDetails[];
  entityPills?: Pill[];
  icon?: JSX.Element;
};

export const EntityDetailsSummary = (props: Props) => {
  const { actions, entityBasicInfo, entityDetails, entityPills, icon } = props;
  const [showDivider, setShowDivider] = useState<boolean>(false);
  const { isMobile, isTablet } = useScreenSize();

  useEffect(() => {
    if (entityDetails) {
      const hasEntityDetailsToDisplay = entityDetails.find((data: EntityDetails) => data.show);
      setShowDivider(!!hasEntityDetailsToDisplay);
    }
  }, [entityDetails]);

  const pills = renderPills(entityPills);
  const basicInfo = renderEntityBasicInfo(entityBasicInfo);
  const entityGrid = renderEntityInfoGrid(entityDetails);
  const actionButtons = renderActions(actions);

  if (isMobile) {
    return (
      <EntityDetailsSummaryMobileView
        icon={icon}
        actions={actions}
        actionButtons={actionButtons}
        basicInfo={basicInfo}
        entityGrid={entityGrid}
        entityPills={entityPills}
        pills={pills}
      />
    );
  }

  if (isTablet) {
    return (
      <EntityDetailsSummaryTabletView
        icon={icon}
        actions={actions}
        actionButtons={actionButtons}
        basicInfo={basicInfo}
        entityGrid={entityGrid}
        entityPills={entityPills}
        pills={pills}
      />
    );
  }

  return (
    <div className="entity-summary-info-card">
      <div className="entity-summary-info-container">
        {icon && icon}
        <div className="entity-summary-details-wrapper">
          <div className="entity-summary-basic-info">
            <div className="entity-summary-basic-info-fields">{basicInfo}</div>
            {entityPills && entityPills.length > 0 && <div className="entity-summary-pills-container">{pills}</div>}
          </div>
          {showDivider && <div className="divider" />}
          <div className="entity-summary-details-fields">{entityGrid}</div>
        </div>
      </div>
      {actions && <div className="entity-summary-actions-container">{actionButtons}</div>}
    </div>
  );
};
